import React from 'react';
import { useParams } from 'react-router-dom';

import CompanyRoleRatesTable from '../components/tables/CompanyRoleRatesTable';

const CompanyRulesPage: React.FC = () => {
  const { companyId } = useParams();
  return <CompanyRoleRatesTable companyId={Number(companyId)} hideCompanyColumn />;
};

export default CompanyRulesPage;
